var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3711_11161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 16,
    rx: 5,
    fill: "#F2F6FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1987 15.62L15.1036 13.5249C15.8978 12.5816 16.2971 11.368 16.218 10.1374C16.1389 8.90685 15.5876 7.75435 14.6791 6.92049C13.7707 6.08663 12.5752 5.63585 11.3424 5.66223C10.1095 5.68861 8.93452 6.19011 8.06256 7.06207C7.1906 7.93403 6.6891 9.10906 6.66272 10.3419C6.63634 11.5748 7.08712 12.7702 7.92098 13.6786C8.75484 14.5871 9.90734 15.1384 11.1379 15.2175C12.3685 15.2966 13.5821 14.8973 14.5254 14.1031L16.6205 16.1982C16.6981 16.2705 16.8006 16.3098 16.9066 16.3079C17.0126 16.3061 17.1137 16.2631 17.1887 16.1882C17.2636 16.1132 17.3066 16.0121 17.3084 15.9061C17.3103 15.8001 17.271 15.6976 17.1987 15.62ZM7.50049 10.4546C7.50049 9.67242 7.73242 8.90785 8.16696 8.25753C8.60149 7.6072 9.2191 7.10034 9.9417 6.80103C10.6643 6.50172 11.4594 6.4234 12.2265 6.57599C12.9936 6.72858 13.6983 7.10521 14.2513 7.65827C14.8044 8.21132 15.181 8.91595 15.3336 9.68306C15.4862 10.4502 15.4079 11.2453 15.1086 11.9679C14.8093 12.6905 14.3024 13.3081 13.6521 13.7426C13.0018 14.1772 12.2372 14.4091 11.455 14.4091C10.4066 14.408 9.4014 13.9909 8.66003 13.2496C7.91866 12.5082 7.50165 11.503 7.50049 10.4546ZM13.0914 10.0455H11.8641V8.81819C11.8641 8.70969 11.821 8.60564 11.7443 8.52892C11.6676 8.4522 11.5635 8.4091 11.455 8.4091C11.3465 8.4091 11.2425 8.4522 11.1658 8.52892C11.0891 8.60564 11.046 8.70969 11.046 8.81819V10.0455H9.81868C9.71018 10.0455 9.60613 10.0886 9.52941 10.1653C9.45269 10.242 9.40959 10.3461 9.40959 10.4546C9.40959 10.5631 9.45269 10.6671 9.52941 10.7438C9.60613 10.8205 9.71018 10.8636 9.81868 10.8636H11.046V12.0909C11.046 12.1994 11.0891 12.3035 11.1658 12.3802C11.2425 12.4569 11.3465 12.5 11.455 12.5C11.5635 12.5 11.6676 12.4569 11.7443 12.3802C11.821 12.3035 11.8641 12.1994 11.8641 12.0909V10.8636H13.0914C13.1999 10.8636 13.304 10.8205 13.3807 10.7438C13.4574 10.6671 13.5005 10.5631 13.5005 10.4546C13.5005 10.3461 13.4574 10.242 13.3807 10.1653C13.304 10.0886 13.1999 10.0455 13.0914 10.0455Z",
    fill: "#325CCD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3711_11161",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3711_11161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3711_11161",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.568bda3e.svg";
export { ForwardRef as ReactComponent };